export default {
  layer: {
    past: [],
    present: {},
    future: []
  }
};
